// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SURFACE DIVISION SCHEMA
/////////////////////////////////////////

export const SurfaceDivisionSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  location: z.string().nullable(),
})

export type SurfaceDivision = z.infer<typeof SurfaceDivisionSchema>

export default SurfaceDivisionSchema;
